// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1816":"65ae864a9f90984b5cc5","3154":"650811901373f2e14bbd","4436":"cbbdb14dd18fa8e61234","5060":"3e27491235701aed8d31"}[chunkId] + ".css";
};